<template>
    <div v-loading="loading">
        <div class="brand-menu">
            <div class="g-wrapper-new brand-menu-text" style="text-align: left;">
                <a href="/">首页</a>
                <img src="../assets/picture/list_btn_more@2x.png" />
                <a :href="'/search?CategoryID=' + categoryID" :title="procInfo.CateName">{{ procInfo.CateName }}</a>
                <img src="../assets/picture/list_btn_more@2x.png" />
                {{ procInfo.Name }}
            </div>
        </div>
        <div class="g-wrapper-new m-product-header">
            <div class="product-pics">
                <div class="m-product-pics" id="productPics">
                    <div class="pics-big">
                        <div class="big-list">
                            <a href="javascript:void 0;" class="item min-img" v-for="(item, key) in procInfo.ExhPic" :key="key">
                                <!-- <vue-magnify
                  :previewImg="minPicSrc"
                  :zoomImg="'https://img.alicdn.com/imgextra/i3/2857774462/TB21fgcwwNlpuFjy0FfXXX3CpXa_!!2857774462.jpg'"
                ></vue-magnify>-->
                                <img
                                    v-lazy="'http://mallmgr.cesseon.com/api/Shop/GetImageSize?width=600&name=' + item.PicName + '&type=1'"
                                />
                            </a>
                        </div>
                    </div>
                    <div class="pics-tab" id="productPicsTab">
                        <div class="tab-wrap">
                            <div class="tab-list">
                                <a
                                    href="javascript:void 0;"
                                    class="item max-img"
                                    v-for="(item, key) in procInfo.ExhPic"
                                    :key="key"
                                    @mouseenter="imgEnter(key)"
                                >
                                    <img
                                        v-lazy="
                                            'http://mallmgr.cesseon.com/api/Shop/GetImageSize?width=240&name=' + item.PicName + '&type=1'
                                        "
                                    />
                                </a>
                            </div>
                        </div>
                        <a href="javascript: void 0;" class="switch prev"></a>
                        <a href="javascript: void 0;" class="switch next"></a>
                    </div>
                </div>
            </div>
            <div class="product-info">
                <div class="m-product-info" style="text-align: left;">
                    <h1 class="product-title">{{ procInfo.Name }}</h1>

                    <!-- 1 表示请购活动 不是 1 表示正常逻辑-->
                    <!--非抢购活动的 其他活动描述-->
                    <div class="activity-desc"></div>

                    <table class="product-pros topper">
                        <!-- 1 表示请购活动 不是 1 表示正常逻辑-->
                        <!--正常活动显示-->
                        <tr class="product-price" data-coupons-after>
                            <th>价格</th>
                            <td style="text-align: left;">
                                <span class="price-current">
                                    ￥
                                    <span v-if="procInfo.IsCustProduct">{{ (procInfo.Price / 100).toFixed(2) }}</span>
                                    <span v-else>????</span>
                                </span>
                                <span class="price-market" v-if="procInfo.Price != procInfo.StandPrice">{{
                                    procInfo.StandPrice / 100
                                }}</span>
                            </td>
                        </tr>
                    </table>

                    <table class="product-pros m-top20">
                        <tr>
                            <th>包装数量</th>
                            <td style="text-align: left;">
                                {{ procInfo.Unit }}
                            </td>
                        </tr>

                        <tr>
                            <th>备注</th>
                            <td style="text-align: left;">
                                {{ procInfo.Remark }}
                            </td>
                        </tr>
                    </table>

                    <table class="product-pros skus" id="productSkus">
                        <tbody>
                            <tr>
                                <th>颜色</th>
                                <td>
                                    <div class="m-prodsku-line">
                                        <template v-for="(item, key) in procInfo.TagList">
                                            <a
                                                :key="key"
                                                :href="'ProcInfo?sku=' + item.SKU"
                                                class="item"
                                                v-if="procInfo.SKU == item.SKU"
                                                selected
                                                >{{ item.Name }}</a
                                            >
                                            <a :key="key" :href="'ProcInfo?sku=' + item.SKU" class="item" v-else>{{ item.Name }}</a>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="product-pros m-top20">
                        <tr class="buy-count">
                            <th>采购量</th>
                            <td style="text-align: left;">
                                <div class="count-handle" id="countHandle">
                                    <a href="javascript:void 0;" class="btn minus" @click="minus()"></a>
                                    <input type="text" class="input" v-model="byNum" />
                                    <a href="javascript:void 0;" class="btn plus" @click="plus()"></a>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <th></th>
                            <td>
                                <div class="handle-wrap" style="text-align: left;">
                                    <!-- <a href="javascript:void 0;" class="buy-btn btn-red" id="goBuy" alt="立即购买">立即购买</a> -->
                                    <a
                                        v-if="procInfo.IsCustProduct"
                                        href="javascript:void 0;"
                                        class="buy-btn"
                                        id="addShopcart"
                                        alt="加入购物车"
                                        @click="subscribe"
                                        >加入购物车</a
                                    >
                                    <a
                                        v-else
                                        href="javascript:void 0;"
                                        @click="AddInquiryOrder(procInfo.SKUID)"
                                        class="buy-btn"
                                        alt="加入询价单"
                                        >加入询价单</a
                                    >
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td style="text-align: left;">
                                <p class="important-tip">
                                    产品图片仅供参考，不能作为您选型购买的依据。
                                </p>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div class="main-detail-width">
            <div class="detail-attrs-right">
                <div class="J_shop"></div>
                <div class="detail-attrs-right-main">
                    <div class="detail-attrs-right-head">
                        <span class="fl center ft14 a on cursor J_Switch">商品详情</span>
                    </div>
                    <div class="J_shows">
                        <div class="detail-attrs-right-body J_body" v-for="(item, key) in procInfo.InfoPic" :key="key">
                            <p>
                                <img
                                    style="width: 100%; height: 100%;"
                                    alt="3M 9001V 环保自吸过滤式折叠式KN90带阀防尘口罩；9001V环保装"
                                    v-lazy="'http://mallmgr.cesseon.com/res/exhPic/' + item.PicName"
                                />
                            </p>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { GlobalFun } from '@/common/utils';
import { ShopCartApi, GetProductSKUInPortal, QuickInquiry, InquiryOrderApi } from '../common/api';
import $ from 'jquery';
export default {
    name: 'procinfo',
    data() {
        return {
            loading: false,
            procInfo: {},
            pic: '',
            minPicSrc: '',
            maxPicSrc: '',
            userinfo: null,
            byNum: 1,
            categoryID: ''
        };
    },
    methods: {
        imgEnter(key) {
            $('.min-img')
                .not(key)
                .hide()
                .eq(key)
                .show();
        },
        minus() {
            if (this.byNum <= 1) {
                this.$message({
                    message: '采购数不能小于1',
                    type: 'info'
                });
                return;
            }
            --this.byNum;
        },
        plus() {
            ++this.byNum;
        },
        //加入购物车
        async subscribe() {
            ShopCartApi.AddToShoppingCart(this.procInfo.SKUID, this.byNum).then(() => {
                this.$message({
                    message: '加入购物车成功！',
                    type: 'success'
                });
            });
        },
        getProcInfoData() {
            return new Promise(result => {
                let sku = this.getUrlKey('sku');
                if (!sku) {
                    result(false);
                }
                GetProductSKUInPortal(sku).then(res => {
                    result(res);
                });
            });
        },
        getUrlKey: function(name) {
            return (
                decodeURIComponent(
                    (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')
                ) || null
            );
        },
        QuickInquiry(skuid) {
            this.loading = true;
            QuickInquiry(skuid)
                .then(() => {
                    this.$message({
                        message: '询价成功',
                        type: 'success'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        AddInquiryOrder(skuid) {
            this.loading = true;
            InquiryOrderApi.AddToInquirySheet(skuid)
                .then(() => {
                    this.$message({
                        message: '加入成功',
                        type: 'success'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    async created() {
        this.loading = true;
        this.userinfo = await GlobalFun.getCookie('UserInfo');
        try {
            this.procInfo = await this.getProcInfoData();
            this.pic = this.procInfo.ExhPic[0].PicName;
            this.minPicSrc = 'http://mallmgr.cesseon.com/api/Shop/GetImageSize?width=600&name=' + this.pic + '&type=1';
            this.categoryID = this.procInfo.categoryID;
        } catch (e) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    }
};
</script>

<style>
@import url('../assets/css/product.css');
</style>
